// extracted by mini-css-extract-plugin
export default {"modalBody":"modal-body_modalBody__GW0-g"};